module.exports = "/assets/8579d0b4a55c2ab45bdf23c1004edd15.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/RQ.png
// module id = 1795
// module chunks = 0